import { useEffect } from 'react';
import { useErrorStore } from '@/stores/errorStore';
import { errorHandler } from '@/services/errors';

/**
 * Hook to integrate error handler with error store
 */
export const useErrorHandler = () => {
  const { addError, showToast } = useErrorStore();

  useEffect(() => {
    // Subscribe to error handler events
    const unsubscribe = errorHandler.addErrorListener((error) => {
      addError(error);
      
      // Show toast for user-facing errors
      const shouldShowToast = 
        error.code !== 'VALIDATION_ERROR' || // Show all non-validation errors
        error.context !== 'internal'; // Show validation errors unless marked as internal
      
      if (shouldShowToast) {
        showToast(error);
      }
    });

    return unsubscribe;
  }, [addError, showToast]);

  return {
    handleError: (error: unknown, context?: string, showToast?: boolean) => {
      return errorHandler.handleError(error, context);
    },
    showError: (message: string, options?: {
      code?: string;
      context?: string;
      retryable?: boolean;
      showToast?: boolean;
    }) => {
      return errorHandler.showError(message, options as any);
    },
    clearErrors: (context?: string) => {
      errorHandler.clearErrors(context);
    }
  };
};